import React from 'react';
import OutsideClickHandler from 'react-outside-click-handler';

import CircularLoading from '../Common/CircularLoading/CircularLoading';

const { detect } = require('detect-browser');

const browser = detect();

class PdfViewer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showCanvas: true,
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.showPdfViewer === false) {
      const element = document.querySelector('.pdf-viewer');
      if (element) {
        // setting up original classes
        element.classList.add('pdf-open');
        element.classList.add('fade-in-pdf');
        element.classList.remove('fade-out-pdf');
        element.classList.remove('pdf-close');
      }
    }

    if (nextProps.showPdfViewer === true) {
      setTimeout(() => {
        this.showPdfIframe();
      }, 800);
    }
  }

  showPdfIframe = () => {
    const iframe = document.querySelector('#pdf-viewer-iframe');
    const canvas = document.querySelector('.loading-pdf-canvas');

    if (iframe) {
      iframe.classList.remove('d-none');
    }

    if (canvas) {
      canvas.classList.remove('d-none');
    }
  };

  hidePdfIframe = () => {
    const iframe = document.querySelector('#pdf-viewer-iframe');
    iframe.classList.add('d-none');
  };

  closePdfViewer = () => {
    const element = document.querySelector('.pdf-viewer');
    if (element) {
      this.hidePdfIframe();
      this.closeAnimation(element);
      setTimeout(() => {
        element.classList.add('d-none');
        this.props.openPdfViewer(false);
        this.setState({ showCanvas: true });
      }, 700);
    }
  };

  componentWillUnmount() {
    this.props.openPdfViewer(false);
  }

  closeAnimation = (element) => {
    element.classList.remove('fade-in-pdf');
    element.classList.remove('pdf-open');
    element.classList.add('fade-out-pdf');
    element.classList.add('pdf-close');
  };

  hideSpinner = () => {
    const canvas = document.querySelector('.loading-pdf-canvas');
    if (canvas) {
      canvas.classList.add('d-none');
    }
    this.setState({
      showCanvas: false,
    });
  };

  render() {
    let isChrome = false;
    if (
      browser &&
      browser.name === 'chrome' &&
      parseInt(browser.version.substring(0, 2)) >= 77
    ) {
      isChrome = true;
    }

    if (this.props.showPdfViewer) {
      return (
        <OutsideClickHandler
          onOutsideClick={() => {
            this.closePdfViewer();
          }}
        >
          {!this.props.isLoadingPdfLink && (
            <>
              <div className="pdf-viewer pdf-open fade-in-pdf">
                <div className="pdf-viewer-heading">
                  <i
                    className="pdf-viewer-close icon-close"
                    onClick={this.closePdfViewer}
                  />
                  <a
                    className="btn btn-outline-secondary rounded-lg"
                    href={this.props.pdfLink.url}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="icon-document_download7" />
                    Download
                  </a>
                </div>
                <div className="pdf-viewer-body">
                  {isChrome ? (
                    <object
                      title="iframe"
                      id="pdf-viewer-iframe"
                      className="d-none"
                      data={this.props.pdfLink.url}
                      key="pdf-viewer-iframe-key-0"
                      onLoad={this.hideSpinner}
                      type="application/pdf"
                    />
                  ) : (
                    <iframe
                      title="iframe"
                      id="pdf-viewer-iframe"
                      className="d-none"
                      src={this.props.pdfLink.url}
                      key="pdf-viewer-iframe-key-0"
                      onLoad={this.hideSpinner}
                      type="application/pdf"
                    />
                  )}{' '}
                  {this.state.showCanvas && (
                    <div className="loading-pdf-canvas d-none">
                      <CircularLoading className="pdf-loading-gif" />
                    </div>
                  )}
                </div>
              </div>
            </>
          )}
        </OutsideClickHandler>
      );
    }
    return null;
  }
}

export default PdfViewer;
